import React, { useState } from "react";

import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import clubsImage from "../assets/club/clubs-2026.jpg";

const Clubs = () => {
  const [open, setOpen] = useState(false);

  const captains = [
    {
      club: "Science Club",
      captain: "Sayed Mohammad Faisal",
      vice: "Chandra Prakash",
      class1: "X B",
      class2: "IX A",
    },

    {
      club: "Maths Club (Juniors)",
      captain: "Aman Rauniyar",
      vice: "Pawan Yadav",
      class1: "V A",
      class2: "V B",
    },

    {
      club: "Maths Club (Seniors)",
      captain: "Shaharyar Khan",
      vice: "Manaswi Chaurasiya",
      class1: "X C",
      class2: "IX A",
    },

    {
      club: "Quiz Club (J)",
      captain: "Aachal Sahani",
      vice: "Akankasha Chaurasiya",
      class1: "V B",
      class2: "IV A",
    },

    {
      club: "Quiz Club (S)",
      captain: "Yash Yadav",
      vice: "Pragya Patel",
      class1: "X C",
      class2: "IX B",
    },

    {
      club: "Hindi Sahitya Club (J)",
      captain: "Swati Patel",
      vice: "Pallavi Rai",
      class1: "IV B",
      class2: "V A",
    },

    {
      club: "Hindi Sahitya Club (S)",
      captain: "Nitik Kumar Patel",
      vice: "Ramesh Kumar Madhesiya",
      class1: "IX B",
      class2: "IX B",
    },

    {
      club: "English Literature Club (J)",
      captain: "Tejaswani Pandey",
      vice: "Mohammad Irfan",
      class1: "VIB",
      class2: "VIB",
    },

    {
      club: "English Literature Club (S)",
      captain: "Anshika Patel",
      vice: "Mahvish Pathan",
      class1: "X A",
      class2: "IX A",
    },

    {
      club: "Arts Club",
      captain: "Palak Gupta",
      vice: "Harsh Patel",
      class1: "X B",
      class2: "IX A",
    },

    {
      club: "Music & Dance Club",
      captain: "Biyon Jakab Biju",
      vice: "Nikhil Gupta",
      class1: "X A",
      class2: "IX A",
    },

    {
      club: "Cricket Club",
      captain: "Akash Yadav",
      vice: "Omshakti Patel",
      class1: "X A",
      class2: "IX B",
    },

    {
      club: "Volleyball Club",
      captain: "Vishal Yadav",
      vice: "Dhananjay Tiwari",
      class1: "X",
      class2: "XB",
    },

    {
      club: "Basket Ball Club",
      captain: "Kunal Patel",
      vice: "Ashutosh Yadav",
      class1: "IXA",
      class2: "XA",
    },

    {
      club: "Badminton Club",
      captain: "Ankit Raj",
      vice: "Vishwa Prakash Patel",
      class1: "XA",
      class2: "IVA",
    },

    {
      club: "Taekwondo Club",
      captain: "Vishesh Kumar",
      vice: "Shivam Patel",
      class1: "XC",
      class2: "VI A",
    },

    {
      club: "Chess Club",
      captain: "Anvesh Kumar",
      vice: "Sathyam Jaiswal",
      class1: "X A",
      class2: "IXB",
    },

    {
      club: "Skating Club",
      captain: "Leon Jacob Biju",
      vice: "Anugragh Thomas",
      class1: "VII A",
      class2: "IV A",
    },
  ];

  const teachers = [
    ["Science Club", "K.K. Tripathi"],
    ["Maths Club (Juniors)", "Prashant Patel"],
    ["Maths Club (Seniors)", "Manoj Kumar Gupta"],
    ["Arts Club", "Mamta Kumari"],
    ["Hindi Sahitya Club (J)", "Deepmala Mishra"],
    ["Hindi Sahitya Club (S)", "Angad Kumar Pandey"],
    ["English Literature Club (J)", "Anuradha Singh"],
    ["English Literature Club (S)", "A. Britto"],
    ["Music & Dance Club", "Manu & Priya Gupta"],
    ["Cricket Club", "Ashutosh Upadhyay"],
    ["Volleyball Club", "Dony Ansel K"],
    ["Chess Club", "Deepa Sharma"],
    ["Taekwondo Club", "Pratibha Mishra"],
    ["Basket Ball Club", "A. Britto"],
  ];

  return (
    <>
      <Header toggleSidebar={() => setOpen(true)} />

      <Sidebar
        isOpen={open}
        close={() => setOpen(false)}
      />

      {/* HERO */}
      <div className="bg-[#072F5F] py-20 text-center">

        <h1 className="text-5xl md:text-6xl font-bold text-white">

          CLUBS

        </h1>

        <p className="text-[#D4A017] text-xl mt-5">

          Student Leadership & Activities

        </p>

      </div>
        {/* CLUB DETAILS IMAGE */}
        <div className="max-w-6xl mx-auto px-4 md:px-8 py-10">

          <div className="bg-white rounded-3xl shadow-xl p-4">

            <img
              src={clubsImage}
              alt="Club Details"
              className="
        w-full
        rounded-2xl
        border-2
        border-[#D4A017]
        shadow-lg
      "
            />

          </div>

        </div>

      <div className="max-w-7xl mx-auto px-4 md:px-8 pb-16">

        {/* CAPTAINS TABLE */}
        <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-gray-200">

          <div className="bg-[#D4A017] py-5 text-center">

            <h2 className="text-3xl md:text-4xl font-bold text-white">

              Club Captains & Vice Captains

            </h2>

          </div>

          <div className="overflow-x-auto">

            <table className="w-full min-w-[900px]">

              <thead className="bg-[#072F5F] text-white">

                <tr>

                  <th className="px-6 py-4 text-left">
                    Club
                  </th>

                  <th className="px-6 py-4 text-left">
                    Position
                  </th>

                  <th className="px-6 py-4 text-left">
                    Name
                  </th>

                  <th className="px-6 py-4 text-left">
                    Class
                  </th>

                </tr>

              </thead>

              <tbody>

                {captains.map((item, index) => (
                  <React.Fragment key={index}>

                    <tr className="border-b">

                      <td className="px-6 py-5 font-semibold text-[#072F5F]">

                        {item.club}

                      </td>

                      <td className="px-6 py-5">
                        Captain
                      </td>

                      <td className="px-6 py-5">
                        {item.captain}
                      </td>

                      <td className="px-6 py-5">
                        {item.class1}
                      </td>

                    </tr>

                    <tr className="border-b bg-gray-50">

                      <td className="px-6 py-5"></td>

                      <td className="px-6 py-5">
                        Vice Captain
                      </td>

                      <td className="px-6 py-5">
                        {item.vice}
                      </td>

                      <td className="px-6 py-5">
                        {item.class2}
                      </td>

                    </tr>

                  </React.Fragment>
                ))}

              </tbody>

            </table>

          </div>

        </div>

        {/* TEACHER TABLE */}
        <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-gray-200 mt-16">

          <div className="bg-[#072F5F] py-5 text-center">

            <h2 className="text-3xl md:text-4xl font-bold text-white">

              School Clubs Teacher In-Charge

            </h2>

          </div>

          <div className="overflow-x-auto">

            <table className="w-full min-w-[700px]">

              <thead className="bg-[#D4A017] text-white">

                <tr>

                  <th className="px-6 py-4 text-left">
                    School Clubs
                  </th>

                  <th className="px-6 py-4 text-left">
                    Teacher In-charge
                  </th>

                </tr>

              </thead>

              <tbody>

                {teachers.map((item, index) => (
                  <tr
                    key={index}
                    className="border-b hover:bg-gray-50 transition-all duration-300"
                  >

                    <td className="px-6 py-5 font-semibold text-[#072F5F]">

                      {item[0]}

                    </td>

                    <td className="px-6 py-5">

                      {item[1]}

                    </td>

                  </tr>
                ))}

              </tbody>

            </table>

          </div>

        </div>

        {/* BOTTOM CONTENT */}
        <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12 mt-16 border border-gray-200">

          <h3 className="text-3xl font-bold text-[#072F5F] mb-6">

            About School Clubs

          </h3>

          <p className="text-gray-700 leading-9 text-lg">

            A club is an organization of students formed for
            specific educational, cultural and competitive
            activities. Different clubs in our school help
            students improve leadership qualities, teamwork,
            confidence and creativity.

          </p>

          <p className="text-gray-700 leading-9 text-lg mt-6">

            Students participate actively in sports, quiz,
            literature, arts, science and cultural activities
            throughout the academic year to build discipline,
            communication skills and competitive spirit.

          </p>

        </div>

      </div>

      <Footer />
    </>
  );
};

export default Clubs;